import _ from 'underscore';
import ko from 'knockout';
import config from '@bingads-webui-component-legacy/config/index';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';
import decimalNumber from '@bingads-webui-component-legacy/humanize/decimal';
import pageContext from '@bingads-webui-static-legacy/page-context';
import instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import { isXandrServing } from '@bingads-webui-campaign-react/constants';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
const s$Budget = window.globalLegacySchema.get('Budget');

const accountCurrencyCode = config.get('AccountCurrencyCode');

const DAILY_BUDGET_TYPE = 'DailyStandard';
const DAILY_ACCELERATED_BUDGET_TYPE = 'DailyAccelerated';
const LIFETIME_BUDGET_TYPE = 'LifetimeBudgetStandard';

const dailyBudget = {
  text: i18n.get('BudgetType_DailyStandard'),
  value: DAILY_BUDGET_TYPE,
};

const dailyAcceleratedBudget = {
  text: i18n.get('BudgetType_DailyAccelerated'),
  value: DAILY_ACCELERATED_BUDGET_TYPE,
};

const lifetimeBudget = {
  text: i18n.get('BudgetType_LifetimeBudgetStandard'),
  value: LIFETIME_BUDGET_TYPE,
};

const budgetTypes = [dailyBudget, dailyAcceleratedBudget, lifetimeBudget];

export default class ViewModel {
  constructor({
    Amount,
    Type,
    CampaignType,
    showBudgetMinRecommend,
    CampaignSubType,
    CampaignSettings,
    budgetRange,
    currencySymbol,
  } = {}) {
    const { activity } = instrumentation.createScenarioAndActivity({
      scenarioName: 'InlineBudgetEdit',
      activityName: 'EditBudget',
    });

    koSchema.properties(this, s$Budget, ['Amount', 'Type'], { Amount, Type }, {
      Amount: {
        isValid: (value) => {
          if (_.isNumber(value)) {
            return value >= budgetRange.FloorValue && value <= budgetRange.CeilingValue;
          }

          return true;
        },
        message: Type === LIFETIME_BUDGET_TYPE ?
          i18n.get('Budget_InputValueError_Lifetime')
            .replace('{0}', currencySymbol)
            .replace('{1}', decimalNumber.fromFloatToString(budgetRange.FloorValue))
            .replace('{2}', currencySymbol)
            .replace('{3}', decimalNumber.fromFloatToString(budgetRange.CeilingValue)) :
          i18n.get('Budget_InputValueError_Daily')
            .replace('{0}', accountCurrencyCode)
            .replace('{1}', decimalNumber.fromFloatToString(budgetRange.FloorValue)),
      },
    });

    const requiredValidator = _.result(this.Amount.validators, 'required');

    requiredValidator.nullable = false;
    this.budgetTypes = ko.computed(() => {
      if (pageContext.Permissions.IsDeprecateAcceleratedBudgetEnabled &&
        Type === DAILY_BUDGET_TYPE) {
        return [dailyBudget];
      } else if (Type === LIFETIME_BUDGET_TYPE) {
        return [lifetimeBudget];
      }
      return budgetTypes;
    });
    this.campaignType = CampaignType;
    this.selectedType = ko.observable(_.find(budgetTypes, (type) => {
      return type.value === Type;
    }) || _.first(this.budgetTypes));
    ko.computed(() => {
      this.Type(this.selectedType().value); //eslint-disable-line
    });
    this.showBudgetMinRecommend = ko.computed(() => {
      // eslint-disable-next-line new-cap
      const showBudgetMinRecommendation = showBudgetMinRecommend && Amount && Amount >= 0.1 && this.Amount() && this.Amount() < (Amount * 0.5).toFixed(2) && !isXandrServing(CampaignSubType, CampaignSettings);

      if (showBudgetMinRecommendation) {
        activity.trace('BCCForBudgetMinimumRecommendation: show');
      }
      return showBudgetMinRecommendation;
    }, this);
    this.applySuggestedBudget = () => {
      activity.trace('BCCForBudgetMinimumRecommendation: apply');
      // eslint-disable-next-line new-cap
      this.Amount((Amount * 0.5).toFixed(2) * 1);
    };
    this.applySuggestedBudgetLog = () => {
      // eslint-disable-next-line new-cap
      if (Amount && Amount >= 0.1 && this.Amount() && this.Amount() < (Amount * 0.5).toFixed(2)) {
        // eslint-disable-next-line new-cap
        activity.trace(`Bid${this.Amount()} Less than 50% of current budget${Amount}`);

      }
    };
  }

  isValid() {
    this.errors.clear();
    return this.validate();
  }

  handleErrors(errors) {
    this.errors.clear();
    this.errors.add(errors);
  }
}

